module.exports = __webpack_public_path__ + "img/season.e258d739.svg";